import React from 'react';

import { FooterSection } from '@/data/footerData';

import { FooterContactSection } from './FooterContactSection';
import { FooterLinksSection } from './FooterLinksSection';

interface FooterMixedSectionProps {
  section: FooterSection;
}

export const FooterMixedSection: React.FC<FooterMixedSectionProps> = ({
  section,
}) => {
  return (
    <div className="min-w-0 space-y-6">
      {section.contactInfo && <FooterContactSection section={section} />}
      {section.links && <FooterLinksSection section={section} />}
    </div>
  );
};
